import axios from "axios";

export const getClassiTipiImpExpDatiApi = (filtri = '') => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/tipi-imp-exp-dati/classi/${filtri}`);
};

export const getStrutturaClassiTipiImpExpDatiApi = () => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + "/api/sost/tipi-imp-exp-dati/classi/strutture/")
}

export const aggiungiStrutturaClasseTipoImpExpDatiApi = (classe) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + "/api/sost/tipi-imp-exp-dati/classi/strutture/", classe)
}

export const deleteStrutturaClasseTipoImpExpDatiApi = (id) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/tipi-imp-exp-dati/classi/strutture/${id}`)
}

export const getClasseTipiImpExpDatiByIdApi = (id) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/tipi-imp-exp-dati/classi/${id}`);
};

export const aggiornaClasseTipoImpExpDatiApi = (id, classe) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/tipi-imp-exp-dati/classi/${id}`, classe);
};

export const aggiungiClasseTipoImpExpDatiApi = (classe) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + "/api/sost/tipi-imp-exp-dati/classi/", classe);
};

export const deleteClasseTipoImpExpDatiApi = (id) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/tipi-imp-exp-dati/classi/${id}`)
}

export const getTipiImpExpDatiApi = (filtri = '') => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/tipi-imp-exp-dati/${filtri}`);
};

export const getTipiImpExpDatiPadriApi = (idClasse) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/tipi-imp-exp-dati/padri/${idClasse}`);
};

export const aggiornaTipoImpExpDatiApi = (id, tipo) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/tipi-imp-exp-dati/${id}`, tipo);
};

export const aggiungiTipoImpExpDatiApi = (tipo) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + "/api/sost/tipi-imp-exp-dati/", tipo);
};

export const getTipoImpExpDatiByIdApi = (idTipo) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/tipi-imp-exp-dati/${idTipo}`);
};

export const getStrutturaTipiImpExpDatiApi = (idSel) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/tipi-imp-exp-dati/struttura/${idSel}`);
};

export const deleteTipoImpExpDatiByIdApi = (idTipo) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/tipi-imp-exp-dati/${idTipo}`);
};